import Link from 'next/link'; 
import ProductTile from '@/components/product_tile';  
export default function RelatedProductRow({collectionName, collectionLink, collection}) {

  return collection?.length > 0 ?  (
    <section className="lexcms-product-section-container">
      <h3 className="lexcms-product-section-heading">{collectionName} 
        {collectionName!='Similar Products' &&
        <span> Collection</span>
        }
       </h3>
      <div className="lexcms-product-related-products-content">
        <div className="lexcms-product-tile-grid-container">
          {collection?.map((product, i) => {
           return (<ProductTile product={product} key={i} />)
          })
          }
        </div>
         {collectionLink}
      </div>
    </section>
  ) : (<> </>);
}